import { getImageUrl } from "src/Common/common";

// `label` turns the icon into a labelled button. Without one it stays the
// square icon button used where space is tight, e.g. a PO card on the work
// order page.
// dataTour: Knowledge Base walkthrough anchor (Azure 416).
function PencilButton({ clicked, label, dataTour }) {
  return (
    <div
      onClick={clicked}
      data-tour={dataTour}
      className={`cursor-pointer h-[30px] rounded-[6px] border-[1px] flex items-center justify-center gap-2 ${
        label ? "px-3" : "w-[30px]"
      }`}
    >
      <img
        src={getImageUrl("/images/common/blueedit.png")}
        className="w-[18px]"
      />
      {label && (
        <span className="font-OpenSansSemiBold text-[13px] leading-5 text-blueColor whitespace-nowrap">{label}</span>
      )}
    </div>
  );
}

export default PencilButton;
